import React from 'react';
import './Blog.css';
import HomeNavbar from '../../HomePage/HomeNavbar/HomeNavbar';

const Blog = () => {
    return (
        <div>
            <HomeNavbar></HomeNavbar>
            <div className="blog-main-container">
                <h2>Blogs are coming...</h2>
            </div>
        </div>
    );
};

export default Blog;